import { render, staticRenderFns } from "./AuthLayout1.vue?vue&type=template&id=280f2b94&scoped=true&"
import script from "./AuthLayout1.vue?vue&type=script&lang=js&"
export * from "./AuthLayout1.vue?vue&type=script&lang=js&"
import style0 from "./AuthLayout1.vue?vue&type=style&index=0&id=280f2b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280f2b94",
  null
  
)

export default component.exports